export const WORKFLOWS = [
  {
    slug: "build-a-verified-list-of-the-right-buyers",
    title: "Build a verified list of the right buyers",
    summary: "A list of the people who can actually buy from you, with email, phone and LinkedIn checked before anyone sends a thing.",
    who: [
      "Teams prospecting from a list someone exported months ago",
      "Businesses entering a new market or vertical",
      "Anyone whose cold emails keep bouncing",
    ],
    steps: [
      { kind: "Trigger", label: "Target customer and buyer roles agreed" },
      { label: "Accounts and contacts pulled from data providers" },
      { label: "Email, phone and LinkedIn verified" },
      { label: "Duplicates and bad records removed" },
      { kind: "Result", label: "Clean list loaded into your tools" },
    ],
    tools: ["Data providers", "lemlist", "n8n or Make", "HubSpot or Pipedrive"],
  },
  {
    slug: "reply-to-every-whatsapp-enquiry-in-60-seconds",
    title: "Reply to every WhatsApp enquiry in 60 seconds",
    summary: "Every enquiry gets an answer straight away, day or night, and a booking offer while the buyer is still interested.",
    who: [
      "Clinics, studios and tuition centres that take enquiries on WhatsApp",
      "Any business running ads that send people into a chat",
      "Teams where enquiries arrive outside working hours",
    ],
    steps: [
      { kind: "Trigger", label: "Enquiry arrives on WhatsApp" },
      { label: "Instant reply sent" },
      { label: "Questions answered and lead qualified" },
      { label: "Booking link or slot offered" },
      { kind: "Result", label: "Contact and chat saved in your CRM" },
    ],
    tools: ["WhatsApp Business", "n8n or Make", "Claude", "HubSpot or Pipedrive"],
  },
  {
    slug: "follow-up-a-lead-until-they-book-or-say-no",
    title: "Follow up a lead until they book or say no",
    summary: "One message is not follow-up. This keeps going on a set schedule and stops the moment a lead books or opts out.",
    who: [
      "Sales teams that send one message and move on",
      "Businesses with more leads than time to chase them",
      "Anyone whose follow-up depends on someone remembering",
    ],
    steps: [
      { kind: "Trigger", label: "Lead added or enquiry received" },
      { label: "Follow-up sequence starts" },
      { label: "Messages continue on schedule" },
      { label: "Replies routed to a salesperson" },
      { kind: "Result", label: "Sequence stops on booking or opt-out" },
    ],
    tools: ["lemlist", "n8n or Make", "WhatsApp", "HubSpot or Pipedrive"],
  },
  {
    slug: "send-appointment-reminders-and-recover-no-shows",
    title: "Send appointment reminders and recover no-shows",
    summary: "Reminders go out without anyone sending them, and a no-show gets a rebooking message instead of being written off.",
    who: [
      "Clinics and practices with a booked calendar",
      "Studios and centres running trial classes",
      "Sales teams losing time to missed meetings",
    ],
    steps: [
      { kind: "Trigger", label: "Appointment booked" },
      { label: "Reminder sent 24 hours before" },
      { label: "Reminder sent on the day" },
      { label: "No-show detected" },
      { kind: "Result", label: "Rebooking message sent automatically" },
    ],
    tools: ["WhatsApp", "Google Calendar", "Make or Zapier", "HubSpot or Pipedrive"],
  },
  {
    slug: "win-back-old-leads-automatically",
    title: "Win back old leads automatically",
    summary: "The leads already sitting in your CRM are the cheapest ones you have. This works through them without anyone opening a list.",
    who: [
      "Teams with a CRM full of leads that went quiet",
      "Businesses with past customers who could buy again",
      "Anyone who has run ads for more than a year",
    ],
    steps: [
      { kind: "Trigger", label: "Old leads pulled from your CRM" },
      { label: "Contact details checked and cleaned" },
      { label: "Reactivation message sent" },
      { label: "Replies routed to a salesperson" },
      { kind: "Result", label: "Interested leads moved back into the pipeline" },
    ],
    tools: ["HubSpot or Pipedrive", "lemlist", "n8n", "Claude"],
  },
  {
    slug: "route-new-leads-to-the-right-salesperson",
    title: "Route new leads to the right salesperson",
    summary: "No more leads sitting in a shared inbox while everyone assumes someone else has it.",
    who: [
      "Teams with more than one salesperson",
      "Businesses selling across markets or product lines",
      "Anyone whose leads land in a shared inbox",
    ],
    steps: [
      { kind: "Trigger", label: "New lead arrives" },
      { label: "Scored on fit and intent" },
      { label: "Assigned by territory or product" },
      { label: "Salesperson notified" },
      { kind: "Result", label: "Deal created in your CRM with an owner" },
    ],
    tools: ["HubSpot or Pipedrive", "n8n or Make", "Slack or WhatsApp"],
  },
  {
    slug: "get-a-weekly-pipeline-report-without-opening-the-crm",
    title: "Get a weekly pipeline report without opening the CRM",
    summary: "The numbers you actually check, in your inbox every week, without anyone building a spreadsheet.",
    who: [
      "Founders who want the picture without digging for it",
      "Sales managers running a weekly review",
      "Teams where reporting is somebody's Friday afternoon",
    ],
    steps: [
      { kind: "Trigger", label: "Schedule runs every Monday" },
      { label: "Data pulled from your CRM" },
      { label: "Numbers summarised and formatted" },
      { kind: "Result", label: "Report sent to your inbox or WhatsApp" },
    ],
    tools: ["HubSpot or Pipedrive", "n8n or Make", "Claude", "Email or WhatsApp"],
  },
];

export const getWorkflow = (slug) => WORKFLOWS.find((w) => w.slug === slug);
